import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { DevicesConstants } from '../../../../app/core/routing/services/devices/constants/devices.constants';
import { FACT_TAGS } from '../../../../app/common/constants/device-fact-tags.constant';
import { GlobalConstants } from '../../../../app/common/constants/global.constant';
import { factTagsEnum } from '../../../common/constants/fact-tags-names.constant';
import { CommonService } from '../../../common/services/common.service';
import { PromoContent, PromoContentConfiguration } from '../../asset-library/promo-content/interfaces/promo-content.i';
import { ProfileUpdateResponse } from '../../create-profile/interface/profile.i';
import { PromoContentService } from '../../../../app/core/routing/services/asset-library/promo-content.service';
import { DeviceStoreService } from '../store/device.store';
import { FactTags } from '../../../modules/devices/interface/devices-interface.i';
import { GoogleAnalyticsService } from '../../../../app/modules/google-analytics/google-analytics.service'
import { AppGlobal } from '../../../../app/core/state/app-global';
import { User } from '../../account/login/_models/user.model';

@Component({
  selector: 'iposcen-device-fact-tags',
  templateUrl: './device-fact-tags.component.html',
  styleUrls: ['./device-fact-tags.component.scss']
})
export class DeviceFactTagsComponent implements OnInit, OnDestroy {
  @Output() readonly lastUpdateTime = new EventEmitter();
  @Output() readonly dismissFunc = new EventEmitter();
  @Input() selectLength;
  @Input() deviceInfo;
  inActive: string;
  profileID: string;
  isChecked: boolean;
  deviceFactTags: any = [];
  refreshDeviceTags = [];
  deviceFactTagFilter = [];
  allPromoContentGroups: PromoContent[];
  profileDataResponse: ProfileUpdateResponse;
  configurations: PromoContentConfiguration[];
  displayPromoContentGroups = [];
  saveChangesLabel = GlobalConstants.SAVE_CHANGES;
  cancelLabel = GlobalConstants.CANCEL;
  mediaObjects = [];
  contentGrpData = {} as any;
  deviceFactTagsEnum = factTagsEnum;
  deviceFactTagsJson = [...FACT_TAGS];
  openModalPopup = false;
  isCancel = false;
  deviceFactTagsConst = [];
  successMessage: string;
  description: string;
  processor = GlobalConstants.FACTTAGS_PROCESSOR;
  memory = GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING;
  optaneMemory = GlobalConstants.MEMORY;
  buttonLabelNo = DevicesConstants.NO;
  buttonLabelCancel = DevicesConstants.CANCEL_UPDATE;
  factTagsForProfile: any;
  uncheckShowOnDevice: boolean;
  private ngUnsubscribe = new Subject<boolean>();
  userInfo: { email: string; userId: string; firstName: string; lastName: string; retailerName: string; role: string; retailerID: string; storeID: string; storeName: string; location: string; isCompRxtEnabled: boolean; isRemoveEnabled: boolean; configurations?: string; partnerID?: string; partnerName?: string; };
  isNonConnectedUser: boolean;

  constructor(private cmnService: CommonService,
    private promoContentService: PromoContentService,
    private deviceStoreService: DeviceStoreService,
    private appGlobal: AppGlobal,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.uncheckShowOnDevice = false;
    this.googleAnalyticsService.devieInfoTabName('Fact Tags');
    this.deviceFactTagsJson = JSON.parse(JSON.stringify(this.deviceFactTagsJson));
    this.deviceFactTagsJson.forEach(element => {
      this.deviceFactTagsConst.push(element);
    });
    this.deviceFactTagsConst.forEach(deviceFactTag => {
      if (deviceFactTag.values.name === '') {
        deviceFactTag.values.name = this.deviceFactTagsEnum[deviceFactTag.name];
      }
      deviceFactTag.show = deviceFactTag.name == 'vr' ? false : deviceFactTag.show;
      this.deviceFactTags.push(deviceFactTag);
    });
    
    this.appGlobal.$userAccount
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        this.isNonConnectedUser = this.userInfo.role === GlobalConstants.NON_CONNECTED_USER ? true : false;
    });
    this.getPromoContents();
  }

  dropFactTags(event: CdkDragDrop<string[]>) {
    this.uncheckShowOnDevice = true;
    moveItemInArray(this.deviceFactTags, event.previousIndex, event.currentIndex);
  }

  trackByFactTags(index: number, el: string): number {
    return index;
  }

  dismiss() {
    this.dismissFunc.emit('');
    this.openModalPopup = !this.openModalPopup;
    this.isCancel = false;
  }

  checkMemory(index, event: any, name: string) {
    this.uncheckShowOnDevice = true;
    if (name === this.optaneMemory) {
      if (event.target.checked) {
        const factTagMemory = this.deviceFactTags
          .filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
        factTagMemory[0].show = true;
        factTagMemory[0].required = true;
        factTagMemory[0].values.optane_messaging = true;
        const factTagOptaneMemory = this.deviceFactTags
          .filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_INTEL_OPTANE_MEMORY);
        factTagOptaneMemory[0].show = false;
        factTagOptaneMemory[0].required = true;
        this.isChecked = true;
        if (factTagMemory) {
          this.deviceFactTags[index].show = true;
        } else {
          this.deviceFactTags[index].show = false;
        }

      } else {
        const factTagMemory = this.deviceFactTags.filter(factTag =>
          factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
        factTagMemory[0].required = false;
        factTagMemory[0].show = true;
        factTagMemory[0].values.optane_messaging = false;
        const factTagOptaneMemory = this.deviceFactTags
          .filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_INTEL_OPTANE_MEMORY);
        factTagOptaneMemory[0].show = true;
        factTagOptaneMemory[0].required = false;
        this.isChecked = false;
        if (factTagMemory) {
          this.deviceFactTags[index].show = true;
        } else {
          this.deviceFactTags[index].show = false;
        }

      }
    } else if (name === GlobalConstants.MEMORY_WITHOUT_OPTANE) {
      const factTagMemory = this.deviceFactTags.filter(factTag => factTag.values.name === GlobalConstants.FACTTAGS_MEMORY_OPTANE_MESSAGING);
      if (event.target.checked) {
        factTagMemory[0].show = true;
      } else {
        factTagMemory[0].show = false;
      }
    } else {
      this.deviceFactTags[index].show = event.target.checked;
    }
  }

  getPromoContents() {
    this.promoContentService.getAllPromoContentByUser()
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(getPromoContentResponse => {
        this.allPromoContentGroups = (getPromoContentResponse.promotionalContent as PromoContent[]);
        this.configurations = [];
        if (this.allPromoContentGroups) {
          this.allPromoContentGroups.forEach(promoContentGroup => {
            this.configurations.push(JSON.parse(promoContentGroup.configurations) as PromoContentConfiguration);
          });
        } 
        if (this.deviceStoreService.deviceStoreData !== undefined) {
          const storeData = this.deviceStoreService.deviceStoreData;
          /** if only default fact tags */
          if (storeData.factTags) {
            this.deviceFactTags = JSON.parse(storeData.factTags);
          }
          /** if then added promotional contents as fact tags after first save (EDIT) */
          if (storeData && storeData.promotionalContents) {
            if (storeData.factTags) {
              //Below code is to update a content group from facttags dataset if user modifies (how On Device) selections.
              var i = this.deviceFactTags?.length;
              while (i--) {
                if (this.deviceFactTags[i]?.values?.type === 'StorePromo') {
                  let remove = true;
                  for (let each of storeData.promotionalContents) {
                    if (each.promotionalContentId === this.deviceFactTags[i]?.name && each.showOnDevice) {
                      remove = false;
                      break;
                    }
                  }
                  if (remove) this.deviceFactTags.splice(i, 1);
                }
              }

              storeData.promotionalContents.forEach(promos => {
                let exists = false;
                for (let facts of JSON.parse(storeData.factTags)) {
                  if (facts.name === promos.promotionalContentId) {
                    exists = true;
                    break;
                  }
                }
                /** if promotional contents not exists will bed added to the fact tags */
                if (!exists) {
                  if (this.allPromoContentGroups) {
                    this.allPromoContentGroups.forEach(allpromos => {
                      if (promos.promotionalContentId === allpromos.id) {
                        allpromos.configurations = JSON.parse(allpromos.configurations);
                        const factTagList = {
                          id: 0,
                          configurations: {},
                          pin: false,
                          show: promos.showOnDevice,
                          name: promos.promotionalContentId,
                          required: false,
                          priority: 18,
                          can_edit: true,
                          updated_at: '',
                          values: {
                            display_text: '',
                            type: 'StorePromo',
                            version: '',
                            name: allpromos.configurations['publishedName']
                          },
                          exclude: false,
                          enumVal: ''
                        };
                        this.deviceFactTags.push(factTagList);
                      }
                    });
                  }
                }
              });
            } else {
              storeData.promotionalContents
                .forEach(element => {
                  if (element.promotionalContentId && element.showOnDevice) {
                    if (this.allPromoContentGroups) {
                      this.allPromoContentGroups.forEach(promoContentId => {
                        if (element.promotionalContentId === promoContentId.id) {
                          promoContentId.configurations = JSON.parse(promoContentId.configurations);
                          const factTagList = {
                            id: 0,
                            configurations: {},
                            pin: false,
                            show: element.showOnDevice,
                            name: element.promotionalContentId,
                            required: false,
                            priority: 18,
                            can_edit: true,
                            updated_at: '',
                            values: {
                              display_text: '',
                              type: 'StorePromo',
                              version: '',
                              name: promoContentId.configurations['publishedName']
                            },
                            exclude: false,
                            enumVal: ''
                          };
                          this.deviceFactTags.push(factTagList);
                        }
                      });
                    }
                  }
                });
            }
          }
        }
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  cancel() {
    this.successMessage = DevicesConstants.DEVICE_CANCEL_TITLE;
    this.description = DevicesConstants.DEVICE_CANCEL_DESC;
    this.isCancel = true;
    this.openModalPopup = !this.openModalPopup;
  }

  sendDataToStore() {
    this.googleAnalyticsService.devieInfoChangesSaved('Fact Tags');
    this.openModalPopup = !this.openModalPopup;
    this.successMessage = DevicesConstants.DEVICE_UPDATE_SAVED;
    this.description = DevicesConstants.DEVICE_UPDATE_DESC;
    this.deviceFactTags.forEach((devices, index) => {
      if (devices.priority !== 1) {
        devices.priority = index + 1;
      }
      /** Fix for UAT-456 starts **/ 
      if (devices.values.name === this.deviceFactTagsEnum[DevicesConstants.DEVICE_TYPE]) {
        let deviceName;
        if (this.deviceInfo?.deviceType === DevicesConstants.DEVICE_STANDARD_DESKTOP)  {
          deviceName = DevicesConstants.DEVICE_DESKTOP;
        } else if (this.deviceInfo?.deviceType === DevicesConstants.DEVICE_ALLINONE_DESKTOP) {
          deviceName = DevicesConstants.DEVICE_ALLINONE;
        } else {
          deviceName = this.deviceInfo?.deviceType;
        }
        devices.values.device = deviceName;
      }
      /** UAT-456 ends **/ 
    });
    this.deviceStoreService.updateDeviceData({ factTags: JSON.stringify(this.deviceFactTags) });
    this.isCancel = false;
    this.lastUpdateTime.emit(true);
  }

  closeModal() {
    this.openModalPopup = !this.openModalPopup;
  }

}